import { render, staticRenderFns } from "./AttributeDetails.vue?vue&type=template&id=5d31788e&scoped=true&"
import script from "./AttributeDetails.vue?vue&type=script&lang=js&"
export * from "./AttributeDetails.vue?vue&type=script&lang=js&"
import style0 from "./AttributeDetails.vue?vue&type=style&index=0&id=5d31788e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d31788e",
  null
  
)

export default component.exports